/*
 * Estados de México (31 estados + Ciudad de México).
 *
 * `value` es como se guarda en Mongo: mayúsculas sin acentos, igual que los
 * registros existentes ("NUEVO LEON"). `label` es como se muestra.
 */
export const ESTADOS_MEXICO = [
  { value: 'AGUASCALIENTES', label: 'Aguascalientes' },
  { value: 'BAJA CALIFORNIA', label: 'Baja California' },
  { value: 'BAJA CALIFORNIA SUR', label: 'Baja California Sur' },
  { value: 'CAMPECHE', label: 'Campeche' },
  { value: 'CHIAPAS', label: 'Chiapas' },
  { value: 'CHIHUAHUA', label: 'Chihuahua' },
  { value: 'CIUDAD DE MEXICO', label: 'Ciudad de México' },
  { value: 'COAHUILA', label: 'Coahuila' },
  { value: 'COLIMA', label: 'Colima' },
  { value: 'DURANGO', label: 'Durango' },
  { value: 'ESTADO DE MEXICO', label: 'Estado de México' },
  { value: 'GUANAJUATO', label: 'Guanajuato' },
  { value: 'GUERRERO', label: 'Guerrero' },
  { value: 'HIDALGO', label: 'Hidalgo' },
  { value: 'JALISCO', label: 'Jalisco' },
  { value: 'MICHOACAN', label: 'Michoacán' },
  { value: 'MORELOS', label: 'Morelos' },
  { value: 'NAYARIT', label: 'Nayarit' },
  { value: 'NUEVO LEON', label: 'Nuevo León' },
  { value: 'OAXACA', label: 'Oaxaca' },
  { value: 'PUEBLA', label: 'Puebla' },
  { value: 'QUERETARO', label: 'Querétaro' },
  { value: 'QUINTANA ROO', label: 'Quintana Roo' },
  { value: 'SAN LUIS POTOSI', label: 'San Luis Potosí' },
  { value: 'SINALOA', label: 'Sinaloa' },
  { value: 'SONORA', label: 'Sonora' },
  { value: 'TABASCO', label: 'Tabasco' },
  { value: 'TAMAULIPAS', label: 'Tamaulipas' },
  { value: 'TLAXCALA', label: 'Tlaxcala' },
  { value: 'VERACRUZ', label: 'Veracruz' },
  { value: 'YUCATAN', label: 'Yucatán' },
  { value: 'ZACATECAS', label: 'Zacatecas' },
]

export const ESTADO_PREDETERMINADO = 'SINALOA'

// Nombres oficiales largos y abreviaturas que aparecen en registros viejos
const ALIAS = {
  CDMX: 'CIUDAD DE MEXICO',
  DF: 'CIUDAD DE MEXICO',
  'D F': 'CIUDAD DE MEXICO',
  'DISTRITO FEDERAL': 'CIUDAD DE MEXICO',
  MEXICO: 'ESTADO DE MEXICO',
  EDOMEX: 'ESTADO DE MEXICO',
  'EDO MEX': 'ESTADO DE MEXICO',
  'EDO DE MEXICO': 'ESTADO DE MEXICO',
  'COAHUILA DE ZARAGOZA': 'COAHUILA',
  'MICHOACAN DE OCAMPO': 'MICHOACAN',
  'QUERETARO DE ARTEAGA': 'QUERETARO',
  'VERACRUZ DE IGNACIO DE LA LLAVE': 'VERACRUZ',
}

const VALORES = new Set(ESTADOS_MEXICO.map((e) => e.value))

function clave(valor) {
  return String(valor ?? '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toUpperCase()
    .replace(/[.]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}

/* "Nuevo León" / "CIUDAD DE  MEXICO" / "cdmx" → valor del catálogo; null si no es un estado. */
export function normalizarEstado(valor) {
  const k = clave(valor)
  if (!k) return null
  if (VALORES.has(k)) return k
  return ALIAS[k] || null
}

export function esEstadoValido(valor) {
  return VALORES.has(valor)
}

/* Valor guardado → nombre para mostrar ("NUEVO LEON" → "Nuevo León"); '' si no es un estado. */
export function etiquetaEstado(valor) {
  const normalizado = normalizarEstado(valor)
  const estado = ESTADOS_MEXICO.find((e) => e.value === normalizado)
  return estado ? estado.label : ''
}
